// components/PaymentSummary.tsx
import React from "react";
import { OrderDetail } from "../hooks/types";
import { roundValue } from "../../home/utils/formatters";
import LabelValueRow from "./LabelValueRow";

interface PaymentSummaryProps {
  orderData: OrderDetail | null;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({ orderData }) => {
  // Calculate total from Products array
  const calculateTotalFromProducts = () => {
    if (!orderData?.Products) return 0;
    return orderData.Products.reduce((total: number, product) => {
      const price = typeof product.totalPrice === 'string' ? parseFloat(product.totalPrice) : product.totalPrice;
      return total + (price || 0);
    }, 0);
  };

  const calculatedTotal = calculateTotalFromProducts();
  const totalOrderPrice = calculatedTotal > 0 ? calculatedTotal : (orderData?.totalOrderPrice ?? orderData?.totalAmount ?? 0);

  const totalReceived = orderData?.payments?.reduce((sum: number, payment) => sum + (payment.ReceivedAmount || 0), 0) ?? 0;

  const balance = orderData?.RemainingAmount ?? totalOrderPrice - totalReceived;

  // Check if multi-car - based on cars array
  const isMultiCar = orderData?.cars && orderData.cars.length > 1;

  return (
    <div className="border-y border-dashed border-black py-3 mb-3 text-sm">
      {/* Show vehicle count for multi-car orders */}
      {isMultiCar && (
        <LabelValueRow 
          label="Vehicles:" 
          value={`${orderData.cars.length} cars`} 
        />
      )}
      <LabelValueRow label="Total (المجموع):" value={`${roundValue(totalOrderPrice)} ر.ق`} bold />
      <LabelValueRow label="Received (تلقى):" value={`${roundValue(totalReceived)} ر.ق`} />
      <LabelValueRow label="Balance (توازن):" value={`${roundValue(balance)} ر.ق`} bold />
    </div>
  );
};

export default PaymentSummary;